/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */

import "./index.css"
import "./router.css"
import "@fortawesome/react-fontawesome"

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { AppConfigurationProvider } from "./components/AppConfigurationService"
import { I18nextProvider } from "react-i18next"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { MuiProvider } from "./MuiProvider"
import React from "react"
import ReactDOM from "react-dom/client"
import { Routes } from "./routes"
import { createTheme } from "@mui/material"
import i18n from "./i18n"
import reportWebVitals from "./reportWebVitals"
import { LoadingProvider } from "react-ui-components/components/LoadingService"
import { PopupProvider } from "react-ui-components/components/PopupService"
import ErrorBoundary from "react-ui-components/components/ErrorBoundary"

const theme = createTheme({
  palette: {
    mode: "light", // or 'dark'
  },
})

const popupConfig = {
  style: {
    backgroundColor: "#fff",
  },
  contentStyle: {
    padding: 5,
    margin: 1,
  },
}

const root = ReactDOM.createRoot(document.getElementById("root") as any)
root.render(
  <ErrorBoundary
    level="page"
    title="Application Error"
    onError={(error, errorInfo) => {
      // Log to external error reporting service in production
      console.error('Application Error:', error, errorInfo);
    }}
  >
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <I18nextProvider i18n={i18n}>
        <React.StrictMode>
          <AppConfigurationProvider>
            <PopupProvider popupConfig={popupConfig}>
              <MuiProvider theme={theme}>
                <LoadingProvider>
                  <Routes />
                </LoadingProvider>
              </MuiProvider>
            </PopupProvider>
          </AppConfigurationProvider>
        </React.StrictMode>
      </I18nextProvider>
    </LocalizationProvider>
  </ErrorBoundary>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
